// USER DATA
var user_data = false;

// VARIABLES
var is_homepage = $('.section--homepage-hero').length > 0;
var is_product_page = $('.section--product-top').length > 0;
var language = $('html').attr('data-lang');


// HUBSPOT
var set_hubspot_attribute = function( params, email ) {
	
	if( typeof email == 'undefined' ) {
		email = user_data.hbsp.fields.email;
	}
	var ajax_data = {
		'action'			: 'hubspot-attributes',
		'key'				: 'ef10041ea9e6dec01f36e8a0f3cb2b4212d7c7f4',
		'params'			: params,
		'email'				: email
	};
	
	if( ajax_data.email ) {
		
		$.ajax({
			url		: '/wp-admin/admin-ajax.php',
			type	: 'GET',
			data	: ajax_data,
			success	: function(result){
				result = $.parseJSON( result );
			}
		});
	}
}

// UNIT FUNCTIONS

var is_base_unit = function( type ) {
	return base_units[type] == user_data.units[type];
}
var get_unit_rate = function( type ) {
	return user_data.units[type] && unit_conversion[type] ? unit_conversion[type][user_data.units[type]] : 1;
}
var get_converted_unit = function( type, value, round ) {
	
	var rate = get_unit_rate( type );
	round = round ? parseInt( round ) : 3;
	value = parseFloat( value );
	
	if( is_base_unit( type ) ) return value.round_decimal( round );
		
	if( isNaN( rate ) ) {
		if( rate[1] == 'inverse' ) {
			return ( rate[0] / value ).round_decimal( round );
		}
	} else {
		return ( rate * value ).round_decimal( round );
	}
}
var get_reverse_converted_unit = function( type, value, round ) {

	var rate = get_unit_rate( type );
	round = round ? parseInt( round ) : 3;
	value = parseFloat( value );
	
	if( is_base_unit( type ) ) return value.round_decimal( round );

	if( isNaN( rate ) ) {
		if( rate[1] == 'inverse' ) {
			return ( rate[0] / value ).round_decimal( round );
		}
	} else {
		return ( value / rate  ).round_decimal( round );
	}
}
var round_decimal = function( number, round ) {
	if( ! round ) round = 3;
	return parseFloat( number.toFixed( round ) );
}
Number.prototype.round_decimal = function( round ) {
	if( ! round ) round = 3;
	return parseFloat( this.toFixed( round ) );
};
String.prototype.round_decimal = function( round ) {
	if( ! round ) round = 3;
	return parseFloat( parseFloat( this ).toFixed( round ) );
};

Number.prototype.comma_number = function() {
	return this <= 9999 ? this : this.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
String.prototype.comma_number = function( round ) {
	if( ! round ) round = 3;
	var comma_num = parseFloat( parseFloat( this.replace( /[^0-9.]/g, '' ) ).toFixed( round ) );
	return isNaN( comma_num ) ? '' : ( comma_num <= 9999 ? comma_num : comma_num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') );
};

// TO DO: CONVERT SLIDER STEPS WHEN UNITS ARE CHANGED
var update_converted_slider = function( filter_name ) {
	
	if( typeof input_sliders !== 'undefined' && input_sliders[filter_name] ) {
		var $elem = $(input_sliders[filter_name].elem);

		var data_min = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-min') );
		var data_max = get_converted_unit( $elem.attr('data-unit-convert'), $elem.attr('data-max') );
		
		if( data_min > data_max ) {
			var temp_max = data_min;
			var temp_min = data_max;
			data_min = temp_min;
			data_max = temp_max;
		}

		// IF INTERACTED, GET VALUES
		if( input_sliders[filter_name].interacted ) {
			if( input_sliders[filter_name].range ) {
				var data_values = [];
				$.each( input_sliders[filter_name].base_value.split(','), function(key, value){
					data_values.push( get_converted_unit( $elem.attr('data-unit-convert'), value ) );
				} )
				if( data_values[0] > data_values[1] ) data_values = [ data_values[1], data_values[0] ];
			} else {
				var data_values = get_converted_unit( $elem.attr('data-unit-convert'), input_sliders[filter_name].base_value );
			}
		} else if( input_sliders[filter_name].range ) {
			data_values = [ data_min, data_max ];
		} else {
			data_values = data_min;
		}

		input_sliders[filter_name].steps = get_step_values_array( data_min, data_max, data_values );
				
		input_sliders[filter_name].elem.noUiSlider.updateOptions({
			range: {
				'min': 0,
				'max': input_sliders[filter_name].steps.length - 1
			}
		});

		input_sliders[filter_name].elem.noUiSlider.set( data_values );
	}
}

var update_units = function( unit_key, unit ) {
	if( ! unit ) unit = user_data.units[unit_key];
	if( ! unit ) return;
	
	$('[data-unit-convert="' + unit_key + '"]').each(function(){
		var round = $(this).is('[data-unit-round]') ? parseInt( $(this).attr('data-unit-round') ) : 3;
		updated_unit = get_converted_unit( unit_key, $(this).attr('data-unit-base'), round );
		
		if( $(this).is('input') ) {
			$(this).val( updated_unit );
		} else if( $(this).find('span').length > 0 ) {
			$(this).find('span').text( updated_unit.comma_number() );
		} else if( $(this).find('input').length > 0 ) {
			$(this).find('input').val( updated_unit.comma_number() );
		} else if( ! isNaN( updated_unit ) ) {
			$(this).text( updated_unit );
		}
		
		// COULD SWITCH TO RE-SUBMITTING BROWSE FORM
		if( $(this).find('input[data-type="number"]').length > 0 ) {
			$(this).find('input[data-type="number"]').each(function(){
				$(this).val( updated_unit );
				if( $(this).attr('max') && $(this).attr('min') ) {
					var $numbers = $(this).closest('.range-wrap-inputs').find('input[data-type="number"]');
					if( $numbers.length > 1 && Array.isArray(unit_conversion[unit_key][unit]) && unit_conversion[unit_key][unit][1] == 'inverse' ) {
						var $number = $(this).is( $numbers.get(0) ) ? $($numbers.get(1)) : $($numbers.get(0));
					} else {
						var $number = $(this);
					}

					var min = get_converted_unit( unit_key, $number.attr('data-unit-base-max'), round );
					var max = get_converted_unit( unit_key, $number.attr('data-unit-base-min'), round );

					// HANDLING FOR INVERSE
					if( min > max ) {
						$number.attr('min', max);
						$number.attr('max', min);
					} else {
						$number.attr('min', min);
						$number.attr('max', max);
					}
				}
			})
		}
		update_converted_slider( $(this).attr('id') );
	});
	$('[data-units="' + unit_key + '"]').each(function(){
		$(this).find('option').prop('selected', false).filter('[value="' + unit + '"]').prop('selected', true);
		$(this).siblings('.placeholder').text(unit);
	});
	$('[data-unit-text="' + unit_key + '"]').each(function(){
		if( $(this).find('span').length > 0 ) {
			$(this).find('span').text( unit );
		} else {
			$(this).text( unit );
		}
	})
}

var update_all_units = function() {
	$.each( unit_conversion, function(key, value){
		update_units( key );
	})
}

$(document).on('change', '[data-units]', function(e){
	user_data.units[$(this).attr('data-units')] = $(this).val();
	save_user_data();
	update_units($(this).attr('data-units'));
	set_dataLayer({
		'event'		: 'ui',
		'action'	: 'change',
		'category'	: 'unit ui',
		'unit'		: $(this).attr('data-units'),
		'label'		: $(this).val()
	});
})

// SET DATALAYER (ABSTRACTION FOR DEBUGGING)
var set_dataLayer = function( json ){
	if( user_data && user_data.cookies == 'yes' ) {
		dataLayer.push( json );
	}
};

// PERSISTENT OBJECT
var set_user_data = function(){
	var temp_user_data = localStorage.getItem( 'user_data' ) ? localStorage.getItem( 'user_data' ) : browser_storage_get( 'user_data' );

	if( typeof temp_user_data === 'string' || temp_user_data instanceof String ) {
		user_data = JSON.parse( temp_user_data );
	} else {
		user_data = {
			'language'	: language,
			'industry'	: false,
			'industries': [],
			'products'	: [],
			'cookies'	: 'yes',
			'units' 	: {
				'temperature'	: 'F',
				'length'		: 'mm',
				'pressure'		: 'psi',
				'flowrate'		: 'L/min'
			},
			'gate_content'	: false,
			'hbsp'		: {
				'fields'		: {
					'email'		: false,
					'firstname'	: false,
					'lastname'	: false,
					'company'	: false,
					'jobtitle'	: false,
					'address'	: false,
					'city'		: false,
					'state'		: false,
					'country'	: false,
					'zip'		: false
				},
				'consent'		: {
					
				},
				'forms'			: [
					
				]
			},
		};
		
		if( $('html').attr('data-country') == 'US' ) {
			user_data.units.length = 'in';
		}
		
		browser_storage_set( 'user_data', JSON.stringify( user_data ) );
	}
	
	update_all_units();
};

// ADD MEDIA TO LIST OF VISITED MEDIA
var update_user_data_visited = function( id ) {
	id = parseInt( id );
	if( user_data.visited.indexOf( id ) === -1 ) {
		user_data.visited.push( id );
		browser_storage_set( 'user_data', JSON.stringify( user_data ) );
	}
}

// SAVE USER DATA TO LOCAL STORAGE
var save_user_data = function() {
	browser_storage_set( 'user_data', JSON.stringify( user_data ) )
}

// SET USER UNITS
var set_user_units = function() {
	$('[data-unit-type]').each(function(){
		if( typeof user_data.units[$(this).attr('data-unit-type')] !== 'undefined' ) {
			var user_unit = user_data.units[$(this).attr('data-unit-type')];
			if( $(this).find( $('[value="' + user_unit + '"]') ) && $(this).val() != user_unit ) {
				$(this).closest('.select-wrap').find('.placeholder').text(user_unit);
				$(this).val( user_unit ).trigger('change');
			}
		}
	})
}

// DATA UNITS
$(document).on('change', '[data-unit-type]', function(){
	if( typeof user_data.units[$(this).attr('data-unit-type')] !== 'undefined' ) {
		user_data.units[$(this).attr('data-unit-type')] = $(this).val();
		save_user_data();
	}
	set_user_units();
})

// RESET USER DATA, RELOAD
$(document).on('click', '[data-reset-userdata]', function(e){
	e.preventDefault();
	var redirect = user_data.industry ? window.location.href.replaceAll('&industry=' + user_data.industry.id, '') : window.location.href;
	localStorage.clear();
	sessionStorage.clear();
	set_user_data();
	window.location = redirect;
})

// RESIZE NAV BASED ON HERO
var resize_industry_nav = function() {
	$('.nav-industry').css('min-height', $('.section-hero').outerHeight());
}

// SOME HOMEPAGE FUNCTIONS
var homepage_video_default = 'default';

var set_homepage_industry = function(){
	// UPDATE SUPERTEXT
	homepage_video_default = user_data.industry.id;
	$('.section--homepage-hero,.section--applications,.section--split-content-slider,.section--resource-slider,.section--product-type-slider').find('.supertext').each(function(){
		if( $(this).find('.industry-supertext').length == 0 ) {
			$(this).prepend('<span class="industry-supertext"></span>');
		}
		$(this).find('.industry-supertext').html('<strong>' + user_data.industry.title + '</strong> | ');
	});
	// UPDATE HERO VIDEO
	$('.homepage-hero-industry-wrapper').removeClass('active').filter('[data-industry="' + homepage_video_default + '"]').addClass('active');
	$('.homepage-hero-industry-wrapper').find('.lazy-load').each(function(){
		if( lazy_elems[parseInt( $(this).attr('data-lazy-key') )] ) {
			lazy_reflow( parseInt( $(this).attr('data-lazy-key') ) );
		}
	});

	// HOMEPAGE APPLICATION
	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'POST',
		data	: {
			action			: 'homepage-applications',
			industry		: user_data.industry.id,
			lang			: language
		},
		success	: function(result){
			if( result ) {
				// CUSTOMIZE CONTENT
				var $cur_wrapper = $('.section--applications .application-card-wrapper');
				$cur_wrapper.html(result);
				get_new_lazy_elems();
				$(window).trigger('scroll');
			}
		},
		error : function(result){
		},
	});

	// HOMEPAGE PRODUCT SLIDER	
	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'POST',
		data	: {
			action			: 'homepage-products',
			industry		: user_data.industry.id,
			lang			: language
		},
		success	: function(result){
			if( result ) {
				// CUSTOMIZE SIDEBAR
				var $cur_swiper = $('.section--product-type-slider .swiper-container');
				$cur_swiper.find('.swiper-wrapper').html(result);
				
				if( swipers[$cur_swiper.attr('data-swiper-id')] ) {
					get_new_lazy_elems();
					swipers[$cur_swiper.attr('data-swiper-id')].update();
					swipers[$cur_swiper.attr('data-swiper-id')].slideTo(0);
					set_swiper_pagination( swipers[$cur_swiper.attr('data-swiper-id')] );

					show_hide_swiper_nav();
					$(window).trigger('scroll');
				}
			}
		},
		error : function(result){
		},
	});
	
	// HOMEPAGE INSIGHT SLIDER
	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'POST',
		data	: {
			action			: 'homepage-insights',
			industry		: user_data.industry.id,
			lang			: language
		},
		success	: function(result){
			if( result ) {
				// CUSTOMIZE CONTENT
				var $cur_swiper = $('.section--resource-slider .swiper-container');
				$cur_swiper.find('.swiper-wrapper').html(result);
				
				if( swipers[$cur_swiper.attr('data-swiper-id')] ) {
					get_new_lazy_elems();
					swipers[$cur_swiper.attr('data-swiper-id')].update();
					swipers[$cur_swiper.attr('data-swiper-id')].slideTo(0);
					set_swiper_pagination( swipers[$cur_swiper.attr('data-swiper-id')] );
					show_hide_swiper_nav();
					$(window).trigger('scroll');
				}
			}
		},
		error : function(result){
		},
	});
	
	
	if( typeof homepage_industry_content != false ) {
		$.each(homepage_industry_content,function(key, industry_object){
			if( parseInt( industry_object.industry ) == user_data.industry.id ) {
				if( industry_object.headline ) {
					$('.section--homepage-hero .hero-content h1').html( industry_object.headline );
				}
				if( industry_object.indent_symbol ) {
					$('.section--homepage-hero .hero-content .indent-symbol').replaceWith('<div class="indent-line indent-symbol--' + industry_object.indent_symbol + '"><span></span></div>');
				}
				if( industry_object.text ) {
					$('.section--homepage-hero .hero-content .cms').html( industry_object.text );
				}

				if( industry_object.products_all_link ) {
					$('.section--product-type-slider .btn-wrapper a').attr('href', industry_object.products_all_link.url ).html( industry_object.products_all_link.title );
				}

				if( industry_object.support_resources_link ) {
					$('.section--three-column-cta-grid .top-wrapper .btn-wrapper a').attr('href', industry_object.support_resources_link.url ).html( industry_object.support_resources_link.title );
				}
				if( industry_object.support_resources_headline ) {
					$('.section--three-column-cta-grid .top-wrapper h3').html( industry_object.support_resources_headline );
				}
				if( industry_object.support_resources_text ) {
					$('.section--three-column-cta-grid .top-wrapper .cms').html( industry_object.support_resources_text );
				}
			}
		})
		resize_industry_nav();
	}
}

var set_product_page = function() {
	// HOMEPAGE INSIGHT SLIDER
	$.ajax({
		url		: '/wp-admin/admin-ajax.php',
		type	: 'POST',
		data	: {
			action			: 'product-page-related',
			product			: $('body').attr('data-post-id'),
			industry		: user_data.industry.id,
			lang			: language
		},
		success	: function(result){
			if( result ) {
				$('[data-product-target]').html(result);
				get_new_lazy_elems();
				$(window).trigger('resize');
			}
		},
		error : function(result){
		},
	});
}

// READY FUNCTION
set_user_data();
$(document).ready(function(){
	check_switch_industry( true );
	resize_industry_nav();
	set_industry_in_nav();
	set_user_units();
	$('select[data-prevent-autoload]').prop('data-prevent-autoload', false);
});

var set_industry_in_nav = function( industry_json ) {
	// if( user_data.cookies == 'yes' ) {
		if( ! industry_json && user_data.industry ) {
			industry_json = user_data.industry;
		}
		if( industry_json ) {

			user_data.industry = industry_json;
			save_user_data();
			$('.nav-industry-header-dropdown select [value="' + industry_json.id + '"]').prop('selected', true);
			$('.nav-industry-header-dropdown .placeholder').text(industry_json.title);
			$('.nav-industry-header-icons-icon img').attr('src', industry_json.icon);
			$('body').addClass('user-industry-set');
			$('[name="lee_industry"]').val(industry_json.title);
			$('[type="hidden"][name="industry"]').val(industry_json.id);
			
			if( is_homepage ) {
				set_homepage_industry();
			}
			if( is_product_page ) {
				set_product_page();
			}
			
			if( $('[data-industry-product-button-link]').length > 0 ) {
				var redirect_url = $('[data-industry-product-button-link]').closest('section').find('[data-set-industry-select] option[data-industry-id="' + industry_json.id + '"]').attr('data-redirect');
				if( redirect_url ) {
					$('[data-industry-product-button-link]').attr('href', redirect_url);
				}
			}
		}
		
		get_set_industry_content();
	// }
}

// INDUSTRY SELECT FUNCTIONS

// SET INDUSTRY BY INDUSTRY ID
var set_industry_by_id = function( id ) {
	$('[data-set-industry-select]:eq(0) option[value="' + id + '"]').prop('selected', true);
	$('[data-set-industry-select]:eq(0)').trigger('change');
	console.log('setting industry by id ', id)
}

// CLICK ELEMENT
$(document).on('click', '[data-set-industry]', function(e){
	e.preventDefault();
	var industry_json = JSON.parse($(this).attr('data-set-industry'));
	set_dataLayer({
		'event'		: 'ui',
		'action'	: 'click',
		'category'	: 'industry ui',
		'industry'	: industry_json.title,
		'label'		: $(this).attr('data-ui-element'),
		'value'		: industry_json.id
	});
	set_industry_in_nav( industry_json );
	set_hubspot_attribute(
		{
			'lee_industry'	: industry_json.title
		}
	);
	if( $(this).is('[data-collapse-banner]') ) {
		$('.nav-banner').slideUp(200);
	}
	check_switch_industry( false );
})

// CHANGE ELEMENT
$(document).on('change', '[data-set-industry-select]', function(e){
	e.preventDefault();
	var industry_json = JSON.parse( $(this).find('option[value="' + $(this).val() + '"]').attr('data-set-industry') );

	console.log('data-set-industry-select', 'onchange', industry_json);

	set_dataLayer({
		'event' 	: 'ui',
		'action'	: 'change',
		'category'	: 'industry ui',
		'industry'	: industry_json.title,
		'label'		: $(this).attr('data-ui-element'),
		'value'		: industry_json.id
	});
	set_industry_in_nav( industry_json );
	set_hubspot_attribute(
		{
			'lee_industry'	: industry_json.title
		}
	);
	if( $(this).is('[data-redirect]') ) {
		window.location.href = $(this).find('option[value="' + $(this).val() + '"]').attr('data-redirect');
	}
	check_switch_industry( false );
})

// CLICK TRACKING
$(document).on('click', '.nav-industry-insights-insight a', function(e){
	set_dataLayer({
		'event' 	: 'ui',
		'category'	: 'industry ui',
		'action'	: 'click',
		'label'		: 'Insight: ' + $(this).closest('.nav-industry-insights-insight').find('h6').text(),
		'value'		: user_data.industry.id
	});
});

var get_set_industry_content = function() {
	console.log('get_set_industry_content');
	
	if( user_data.industry ) {
		
		if( user_data.industry.permalink ) {
			$('[data-current-industry-link]').attr('href', user_data.industry.permalink);
		}
		if( user_data.industry.title ) {
			$('[data-current-industry-title]').text(user_data.industry.title);
		}
		
		var ajax_data = {
			action			: 'industry-menu-items',
			industry		: user_data.industry.id,
			current_page	: parseInt( $('body').attr('data-post-id') ),
			lang			: language
		};
		
		if( $('body').is('[data-product-type]') ) {
			ajax_data.product_type = parseInt(  $('body').attr('data-product-type') )
		}
		
		// SET INDUSTRY VALUE IF NOT SET
		$('[name="industry"]').each(function(){
			if( ! $(this).is('[data-prevent-autoload]') ) {
				$(this).val(user_data.industry.id);
				$(this).closest('.select-wrap').find('.placeholder').html(user_data.industry.title);
			}
		})
		
		// MENU ITEMS
		$.ajax({
			url		: '/wp-admin/admin-ajax.php',
			type	: 'POST',
			data	: ajax_data,
			success	: function(result){
				
				if( result ) {
					result = JSON.parse( result );
					
					// INDUSTRY PRODUCT OVERVIEW (& PRODUCT FINDER LINKS)
					if( result['menu-nav-products-overview'] ) {
						$('.menu-nav-products').attr('href', result['menu-nav-products-overview']);
						$('nav.primary .product-finder-overview').attr('href', result['menu-nav-products-overview']);
					}
					if( result['menu-nav-applications'] ) {
						$('.menu-wrapper--menu-nav-applications').each(function(){
							$(this).find('ul:eq(0)').html(result['menu-nav-applications']);
						})
						if( $('.moble-menu .menu-nav-applications').siblings('.menu-arrow-link').length > 0 ) {
							$('.mobile-menu-screen[data-menu-key="' + $('.moble-menu .menu-nav-applications').siblings('.menu-arrow-link').attr('data-menu-key-to') + '"] ul').html(result['menu-nav-applications']);
						}
					}
					if( result['menu-nav-products'] ) {
						$('.menu-wrapper--menu-nav-products').each(function(){
							$product_nav_before = $(this).find('ul:eq(0) .nav-link-persistent--stick-top').closest('li');
							$product_nav_before = $product_nav_before.length > 0 ? $product_nav_before[0].outerHTML : '';
							$product_nav_after = $(this).find('ul:eq(0) .nav-link-persistent--stick-bottom').closest('li');
							$product_nav_after = $product_nav_after.length > 0 ? $product_nav_after[0].outerHTML : '';
							$(this).find('ul:eq(0)').html($product_nav_before + result['menu-nav-products'] + $product_nav_after);
						})
						if( $('.moble-menu .menu-nav-products').siblings('.menu-arrow-link').length > 0 ) {
							// GET THE PERSISTENT LINKS FROM THE PRIMARY NAV
							$product_nav_before = $('nav.primary .menu-wrapper--menu-nav-products ul:eq(0) .nav-link-persistent--stick-top').closest('li');
							$product_nav_before = $product_nav_before.length > 0 ? $product_nav_before[0].outerHTML : '';
							$product_nav_after = $('nav.primary .menu-wrapper--menu-nav-products ul:eq(0) .nav-link-persistent--stick-bottom').closest('li');
							$product_nav_after = $product_nav_after.length > 0 ? $product_nav_after[0].outerHTML : '';
							$('.mobile-menu-screen[data-menu-key="' + $('.moble-menu .menu-nav-products').siblings('.menu-arrow-link').attr('data-menu-key-to') + '"] ul').html($product_nav_before + result['menu-nav-products'] + $product_nav_after);
						}
					}
				}
			},
			error : function(result){
			},
		});
		
		// INDUSTRY SIDEBAR CONTENT
		var ajax_data = {
			action			: 'nav-industry-content',
			industry		: user_data.industry.id,
			current_page	: parseInt( $('body').attr('data-post-id') ),
			lang			: language
		};
		if( $('body').is('[data-product-type]') ) {
			ajax_data.product_type = parseInt( $('body').attr('data-product-type') )
		}

		$.ajax({
			url		: '/wp-admin/admin-ajax.php',
			type	: 'POST',
			data	: ajax_data,
			success	: function(result){
				// CUSTOMIZE SIDEBAR
				$('body').removeClass('user-industry-preload').removeClass('user-industry-none').addClass('user-industry-set');
				$('.nav-industry-dropdown-industry-content').html( result );
				resize_industry_nav();
			},
			error : function(result){
			},
		});
		
	} else {
		$('body').removeClass('user-industry-preload').addClass('user-industry-none');
	}
}

// RESIZE
$(window).on('resize', function(){
	resize_industry_nav();
});

// CHECK TO SEE IF THE CONTENT IS OF THE INDUSTRY THE USER HAS SELECTED
var check_switch_industry = function( set_click ) {
	// if( $('body').is('[data-industry]') && user_data.cookies == 'yes' ) {
	if( $('body').is('[data-industry]') ) {
		if(
			user_data.industry.id &&
			user_data.industry.id != $('body').attr('data-industry') && 
			$('.nav-banner').length > 0
		) {
			$('.nav-banner').slideDown(200);
		} else if( set_click ) {
			$('.nav-banner [data-set-industry]').trigger('click');
		} else {
			$('.nav-banner').slideUp(200);
		}
	} else if( $('body').is('.single-product') && $('.nav-banner').attr('data-industries') ) {
		let industries = [];
		$.each($('.nav-banner').attr('data-industries').split(','), function(key, value) {
			industries.push( parseInt( value ) );
		})
		if(
			user_data.industry.id &&
			! industries.includes( user_data.industry.id )
		) {
			var ajax_data = {
				'industry' 		: user_data.industry.id,
				'product_type'	: $('.nav-banner').attr('data-product-type'),
				'action'		: 'get-product-type-industry-link'
			};
			$.ajax({
				url: "/wp-admin/admin-ajax.php",
				type: "POST",
				data: ajax_data,
				success: function (result) {
					if( result ) {
						result = JSON.parse( result );
						if( result.type == 'product-type' ) {
							$('[data-current-industry-product-link]').attr('href', result.link).find('[data-product-type]').text($('[data-current-industry-product-link] [data-product-type]').attr('data-product-type'));
						} else {
							$('[data-current-industry-product-link]').attr('href', result.link).find('[data-product-type]').text('Products');
						}
						$('.nav-banner').slideDown(200);
					} else {
						$('[data-current-industry-product-link]').attr('href', user_data.industry.permalink).find('[data-product-type]').text('Products');
					}
				}
			})
		} else {
			$('.nav-banner').slideUp(200);
		}
	}
	
	// RESUBMIT SEARCH FORM IN VERY PARTICULAR INSTANCES
	var param_industry = get_url_param( 'industry' );
	if( param_industry && param_industry != user_data.industry.id && $('.section--search-searching').length > 0 && $('.search-form-industry-wrapper').is(':hidden') ) {
		$('.section--search-searching form').submit();
	}
}